module.exports = __webpack_public_path__ + "img/backArrow.df25f8b5.svg";